// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatInvitationListBody = {
  cursor?: string | null;
};

export type typeChatInvitationListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      chatInvitationId: string;
      chatId: string;
      title: string;
      invitedByDisplayName: string;
      invitedAtIso: string;
      memberCount: number;
    }[];
    nextCursor?: string | null;
  };
};

export type typeChatInvitationListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatInvitationListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatInvitationListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatInvitationListBody = {
  type: "object",
  properties: {
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatInvitationList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatInvitationListBody);
  }

  return async function postChatInvitationList(
    payload: typeChatInvitationListBody,
  ): Promise<
    typeChatInvitationListOutput200 | typeChatInvitationListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatInvitationList" failed before calling the network. #5c073f35ad9d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5c073f35ad9d" },
        },
        data: null,
      } as typeChatInvitationListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat-invitation/list`,
      httpMethod: "POST",
      options,
    })) as typeChatInvitationListOutput200 | typeChatInvitationListOutput400;
  };
}
